<h1 mat-dialog-title>{{ data?.honorar ? 'Lieferant suchen' : 'Nebenkosten-Lieferant suchen' }}</h1>
<div mat-dialog-content class="picker-content">
    <p class="hint" *ngIf="!data?.honorar">
        Suche nach Bezeichnung oder Konto (Kreditor / Aufwand-Gegenkonto). Nur Nebenkosten-Lieferanten.
    </p>
    <p class="hint" *ngIf="data?.honorar">
        Suche nach Lieferanten (optional bei Honoraren).
    </p>

    <mat-form-field appearance="outline" class="full search-field">
        <mat-label>Suche</mat-label>
        <input matInput [formControl]="searchCtrl" placeholder="z.B. Tankstelle, 700005, 4530 …" autofocus />
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <div class="toolbar">
        <span class="result-meta" *ngIf="!loading && (searchCtrl.value || '').trim()">
            {{ results.length }} Treffer
        </span>
        <span class="spacer"></span>
        <button
            *ngIf="canCreate"
            mat-stroked-button
            type="button"
            color="accent"
            (click)="toggleCreate()"
        >
            <mat-icon>{{ showCreate ? 'close' : 'add' }}</mat-icon>
            {{ showCreate ? 'Anlegen abbrechen' : 'Neu anlegen' }}
        </button>
    </div>

    <div class="create-panel" *ngIf="canCreate && showCreate">
        <mat-form-field appearance="outline" class="full">
            <mat-label>Bezeichnung</mat-label>
            <input matInput [formControl]="bezeichnungCtrl" required />
        </mat-form-field>
        <div class="row">
            <mat-form-field appearance="outline" class="half">
                <mat-label>Kreditor-Konto</mat-label>
                <input matInput [formControl]="buchungskontoCtrl" required placeholder="z.B. 700005" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="half">
                <mat-label>Aufwand-Gegenkonto</mat-label>
                <input matInput [formControl]="buchungsgegenkontoCtrl" placeholder="z.B. 4530" />
                <mat-hint>Default 4530 (Kfz-Betrieb)</mat-hint>
            </mat-form-field>
        </div>
        <div class="create-actions">
            <button
                mat-flat-button
                color="accent"
                type="button"
                [disabled]="!isCreateValid() || creating"
                (click)="create()"
            >
                Anlegen und übernehmen
            </button>
        </div>
    </div>

    <div class="loading" *ngIf="loading">Suche …</div>
    <div class="empty" *ngIf="!loading && !(searchCtrl.value || '').trim() && !showCreate">
        Tippe einen Suchbegriff ein.
    </div>
    <div class="empty" *ngIf="!loading && (searchCtrl.value || '').trim() && results.length === 0 && !showCreate">
        Keine Treffer – ggf. neu anlegen.
    </div>

    <div class="result-list" *ngIf="!loading && results.length">
        <button type="button" class="result-row" *ngFor="let row of results" (click)="select(row)">
            <span class="bez">{{ row.bezeichnung }}</span>
            <span class="meta">
                <span class="konto" matTooltip="Kreditor">{{ row.buchungskonto || '–' }}</span>
                <span class="konto" matTooltip="Aufwand">{{ row.buchungsgegenkonto || '–' }}</span>
            </span>
        </button>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">Abbrechen</button>
</div>
